
import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Select from 'react-select';
import Button from 'react-bootstrap/Button';
import { FaPlus, FaTrash } from 'react-icons/fa';

import ApiUiController from '../../controller/ApiUiController';
import FilterDate from '../filter/FilterDate';
import FilterComplexPannel from '../filter/FilterComplexPannel';
import FilterMultiSelect from '../filter/FilterMultiSelect';
import Util from '../../util/Util';
import withRouter from '../../util/WithRouter';
import Const from '../../util/Constants';
import AutomationModuleSelect from '../settings/automation/AutomationModuleSelect';
import ImportExportAPI from "../../api/ImportExportAPI";

class ReportComplexDownloadPreview extends React.Component {

  constructor(props) {
    super(props);
    this.models = reactLocalStorage.getObject(Const.Model);

    this.export = [ ];

    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    this.children = [ user.user_id, ...user.child];

    this.report = props.report;
    this.headers = [];
    this.rows = [];
    this.data = null;
    this.state = { change: true, inApiCall : false };

    this.model = this.report.model.split(' ')[0];
    this.subModel = this.report.sub_model?.split(' ')[0];

    this.modelFields = [];
    this.subModelFields = [];
    let keys = Object.keys(this.models[this.model].fields);
    for(let i = 0; i < keys.length; i++) {
      this.modelFields.push({ 
        id: this.models[this.model].fields[keys[i]].id, 
        value: this.models[this.model].fields[keys[i]].field_key,
        type: this.models[this.model].fields[keys[i]].field_type,
        label: this.models[this.model].fields[keys[i]].label_name 
      });
    }
    this.subModelFields = [];
    if(this.subModel){
      keys = this.models[this.subModel].fields  &&  Object.keys(this.models[this.subModel].fields);
      for(let i = 0; i < (keys && keys.length); i++) {
        this.subModelFields.push({ 
          id: this.models[this.subModel].fields[keys[i]].id, 
          value: this.models[this.subModel].fields[keys[i]].field_key,
          type: this.models[this.subModel].fields[keys[i]].field_type,
          label: this.models[this.subModel].fields[keys[i]].label_name 
        });
        }
    }
    
    const filters = [];
    if(this.report.filter) {
      const filter = JSON.parse(this.report.filter);
      for(let i = 0; i < filter.length; i++) {
        filters.push({ ...filter[i]});
        filters[i].value = FilterDate.getValue(filters[i].value ? filters[i].value : filters[i].condition);
        filters[i].value = FilterMultiSelect.getDefaultValue(filters[i].value);
      }
    }
    this.filters = filters;
    const json = this.report.json ? JSON.parse(this.report.json) : {};
    this.fields = json && json.fields ? json.fields : [];
  }

  onFilterChange = filters => {
    this.setState({ ...this.state, inApiCall: true });
    this.filters = filters;
  }

  onFieldAdd = () => {
    this.fields.push({});
    this.setState({ ...this.state, change: !this.state.change })
  }

  onFieldRemove = index => {
    this.fields = this.fields.filter((_, i) => i !== index);
    this.setState({ ...this.state, change: !this.state.change })
  }

  onExport = () => {
    const additional = {
      report_model: this.model,
      report_sub_model: this.subModel
    }
    this.setState({ ...this.state, inApiCall: true });
    ImportExportAPI.exportModel(Const.Report, this.filters, null, 0, this.fields, 
      Const.Report, this.onExportDone, ()=> {}, additional);
  }
  onExportDone = () => {
    Util.showNotification( "Successful", "Lead Exported in progress. Please visit Settings", "success");
    this.props.navigate(`/setting/export`);
  };


  render() {
    return(
      <ApiUiController inApiCall={this.state.inApiCall}>
        <div className="container-fluid ">
          <div className="row">  
            <div className="col-md-8">
              <div className="row">
                <div className="col-md-6"><h4>{this.report.name}</h4></div>
                <div className="col-md-6">
                  <Button className="buttons btn-success" onClick={this.onExport}>Export</Button>
                </div>
              </div>
            </div>
          </div>
        
          <div className="row pt-3">
            <div className="container-fluid ">
              <div className="row">
                <div className="col-md-9">
                  <div className="formhead col-md-12">
                    <h4>Fields <FaPlus onClick={this.onFieldAdd}/></h4>
                  </div>
                  { this.fields.map((field, i) =>
                    <div className="row row-cols-12 lead-form" key={`fields_${i + 1}`}>
                      <div className="col-md-4">
                        <AutomationModuleSelect
                          model={field.model}
                          models={this.models}
                          restricted={[ this.model, this.subModel ]}
                          onChange={(field, model) => {
                            this.fields[i].model = model;
                            this.setState({ ...this.state, change: !this.state.change });
                          }}
                        />
                      </div>

                      <div className="col-md-4">
                        <Select 
                          value={(field.model === this.model ? this.modelFields
                            : field.model === this.subModel ? this.subModelFields
                            : [])
                            .find(innerField => innerField.value === field.field)
                          } 
                          className="mr-sm-2"
                          options={field.model === this.model ? this.modelFields
                            : field.model === this.subModel ? this.subModelFields
                            : []
                          }
                          onChange={field => {
                            this.fields[i].field = field ? field.value : '';
                            this.setState({ ...this.state, change: !this.state.change });
                          }}
                          isSearchable={true} isClearable={true} />
                      </div>

                      <FaTrash onClick={() => this.onFieldRemove(i)} />
                    </div>
                  )}
                </div>
                <FilterComplexPannel 
                  filters={this.filters}
                  modelX={this.models[this.model]}
                  modelY={this.models[this.subModel]}
                  onFilterChange={this.onFilterChange} 
                  isFilterOpen={true}
                  restrict={this.Restrict} />
              </div>
            </div>
          </div>
        </div>
      </ApiUiController>
    );
  }
}
export default withRouter(ReportComplexDownloadPreview);